import { NgModule } from '@angular/core';
import { Routes, RouterModule } from '@angular/router';
import { StaffDataComponent} from './staff-data.component'
const routes: Routes = [
  {
    path: '',
    component: StaffDataComponent
  }
];
@NgModule({
  imports: [RouterModule.forChild(routes)],
  exports: [RouterModule]
})
export class StaffDataRoutingModule { }
